export enum QuizSettings {
  SCHEME = 'quizSetting:scheme',
  BUTTONS_REVERSED = 'quizSetting:quizButtonReversed',
  FLASHCARDS_FLAG_VISIBLE = 'quizSetting:flagVisible',
  FLASHCARDS_NO_REPEAT = 'quizSetting:noRepeat',
}
